import types from './ActionTypes';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import postData from 'Utils/PostData';
import patchData from 'Utils/PatchData';
import deleteData from 'Utils/DeleteData';

// interface
import { IConceptData } from 'store/StateInterfaces';

// load req
export function loadConceptDataRequest(conceptId: number) {
    return dispatch => {
        const url = `/concept/api/concept/${conceptId}/get_concept_page_data/`;
        return fetch(url)
            .then(res => res.json())
            .then(res => {
                dispatch(loadConceptDataSuccess(conceptId, res));
            })
            .catch(err => {
                displayGlobalMessage('Concept Data Loading failed', 'error');
                throw (err);
            })
    }
}

export function loadConceptDataSuccess(conceptId: number, data: IConceptData) {
    return {
        type: types.LOAD_STUDENT_CONCEPT_DATA_SUCCESS,
        conceptId,
        data
    }
}

